import USP from './USP-view';

export default USP;
